/* eslint-disable radix */
import React from "react";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import { getSection } from "src/hooks/useContentful/getSection";
import { useOffer } from "../../hooks/offer";
import CustomLink from "../CustomLink";
import Loading from "../Loading";

import {
  WrapperContainer,
  BlocoInterno,
  HeaderContainer,
  PartnerImg,
  ImgLogo,
  PartnerContainer,
} from "./styles";
import { useMedia } from "use-media";
export default function Header() {
  const isMobile = useMedia({ maxWidth: 767 });
  const { currentOffer } = useOffer();
  const { data, isLoading } = useFetchContent();

  if (isLoading || !data) return <Loading />;

  const { isGeneric } = data.fields;
  const section = getSection({ sectionName: "landingNav", data });
  const parceiroLogo = section.parceiroLogo.fields.file.url;
  const veloeLogo = section.veloeLogo.fields.file.url;

  return (
    <WrapperContainer>
      <BlocoInterno>
        <HeaderContainer>
          <CustomLink
            to="/gwmbrasil"
            tagLabel="logo-veloe"
            parentComponent="menu"
          >
            <div className="logo">
              <ImgLogo>
                <img src={`https://${veloeLogo}`} alt={veloeLogo} />
              </ImgLogo>
            </div>
          </CustomLink>
          {currentOffer && currentOffer.logo ? (
            <PartnerContainer>
              <PartnerImg src={currentOffer.logo} alt="Parceiro" />
            </PartnerContainer>
          ) : !isGeneric && parceiroLogo ? (
            <PartnerContainer>
              {isMobile ? (
                <PartnerImg src={parceiroLogo} alt="Parceiro" />
              ) : (
                <PartnerImg src={parceiroLogo} alt="Parceiro" />
              )}
            </PartnerContainer>
          ) : null}
        </HeaderContainer>
      </BlocoInterno>
    </WrapperContainer>
  );
}

// Header.propTypes = {};

// export default Header;
